import React, { Fragment, useState, useEffect, useReducer } from "react";
import VerifyUser from './VerifyUser';
import UpdateRecoveryDetails from './UpdateRecoveryDetails';
import SelectRecoveryMethod from './SelectRecoveryMethod';
import RecoverInstructions from './RecoverInstructions';
import { api, useApi } from '../../services/api';

const gtag = window && typeof window.gtag === 'function' ? window.gtag : null;

function PasswordRecovery({ apiUrl, apiToken, recoveryIntentId, recoveryToken, gaTrackingId }){
	
	const [ recoveryIntent, getRecoveryIntent ] = useApi();
	const [intentStatus, setIntentStatus] = useState();
	const [ localRecoveryToken, setLocalRecoveryToken ] = useState(recoveryToken);

	useEffect( () => {
		if(!gtag){
			return; }

		gtag('set', 'app_name', 'PasswordRecovery');

	}, []);

	useEffect( () => {
		api.defaults.baseURL = apiUrl;
		api.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
	}, [apiUrl, apiToken]);


	useEffect( () => {
		getRecoveryIntent(`/api/v1/provisioning/recovery_intents/${recoveryIntentId}`);
	}, [recoveryIntentId]);
	

	useEffect( () => {
		if(recoveryIntent.isError){
			if(recoveryIntent.errorStatus === 401){
				window.location.reload(); }
		}else if(recoveryIntent.isLoading){
		}else if(recoveryIntent.data){
			const intent = recoveryIntent.data.recovery_intent;
			
			setIntentStatus(intent.status);

			if(intent.recover_instructions && intent.recover_instructions.temporary_token){
				setLocalRecoveryToken(intent.recover_instructions.temporary_token);
			}
		}
	}, [recoveryIntent]);

	useEffect( () => {
		if(!gtag){
			return; }

		let screen_name;
		switch(intentStatus){
			case 1:
				screen_name = '/select_recovery_method';
				break;
			case 2:
				screen_name = '/verify_user';
				break;
			case 3:
				screen_name = '/update_recovery_details';
				break;

			// case 4: manage its own screen name
		}

		if(screen_name){
			gtag('event', 'screen_view', { screen_name }); }
		

	}, [intentStatus]);

	switch(intentStatus){
		case 1:
			return (<SelectRecoveryMethod 
				recoveryIntent={recoveryIntent} 
				getRecoveryIntent={getRecoveryIntent} />);

		case 2:
			return (<VerifyUser
				recoveryIntent={recoveryIntent} 
				getRecoveryIntent={getRecoveryIntent} />);

		case 3:
			return (<UpdateRecoveryDetails 
				recoveryIntent={recoveryIntent} 
				getRecoveryIntent={getRecoveryIntent} />);

		case 4:
			return (<RecoverInstructions
				recoveryIntent={recoveryIntent} 
				getRecoveryIntent={getRecoveryIntent}
				recoveryToken={localRecoveryToken} />);

		default:
			// TODO: loading...
			return (<div className="progress">
				<div className="progress-bar progress-bar-striped progress-bar-animated w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
			</div>);
	}
}

export default PasswordRecovery;
